module.exports = __webpack_public_path__ + "img/xvs.27250395.png";